/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_15_DInputs */

const en_tut_gl_15_d = /** @type {(inputs: Tut_Gl_15_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic notes of what was said in a meeting with speaker names; kept 90 days and deletable by the host sooner.`)
};

const id_tut_gl_15_d = /** @type {(inputs: Tut_Gl_15_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan otomatis pembicaraan rapat beserta nama pembicara; disimpan 90 hari dan bisa dihapus host lebih awal.`)
};

/**
* | output |
* | --- |
* | "Automatic notes of what was said in a meeting with speaker names; kept 90 days and deletable by the host sooner." |
*
* @param {Tut_Gl_15_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_15_d = /** @type {((inputs?: Tut_Gl_15_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_15_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_15_d(inputs)
	return en_tut_gl_15_d(inputs)
});